import MonitorioFormView from 'src/components/views/EscritosLexnet/components/Monitorio/MonitorioFormView'
import SubmitForm from 'src/components/views/EscritosLexnet/components/shared/components/SubmitForm'

type MonitorioFormPropsTyps = {
  section: string
}

function MonitorioForm({ section }: MonitorioFormPropsTyps): JSX.Element {
  return (
    <SubmitForm>
      <MonitorioFormView section={section} />
    </SubmitForm>
  )
}

export default MonitorioForm
